import React, { useContext, useState } from 'react';
import HelpSection from '../HelpSection';
import { AuthContext } from '../../context/Auth.context';
import { ProfileContext } from '../../context/Profile.context';

import { Info, CircleQuestionMark } from 'lucide-react';
import { Box, Button, Dialog, DialogContent, DialogTitle, Typography } from '@otcmarketsgroup/otcm-ui-lib';
import { testIds } from '../../constants/testIds';

const INSTRUCTIONS = 'instructions';
const HELP = 'help';

const FormSupportActions = () => {
    const [openDialog, setOpenDialog] = useState(null);
    const [authState] = useContext(AuthContext);
    const [profileState] = useContext(ProfileContext);

    const { email: userEmail, firstName, lastName } = authState?.user ?? {};
    const userFullName = `${firstName} ${lastName}`;
    const { profile: { companyInfo: { companyName } } } = profileState;

    const handleClose = () => setOpenDialog(null);

    return (
        <>
            <Box display='flex' flexDirection='column' gap={1}>
                <Button
                    fullWidth
                    variant='outlined'
                    endIcon={<Info size={16} />}
                    data-testid={testIds.support.instructionsBtn}
                    onClick={() => setOpenDialog(INSTRUCTIONS)}
                >
                    View Instructions
                </Button>
                <Button
                    fullWidth
                    variant='outlined'
                    endIcon={<CircleQuestionMark size={16} />}
                    data-testid={testIds.support.helpBtn}
                    onClick={() => setOpenDialog(HELP)}
                >
                    Help
                </Button>
            </Box>

            <Dialog open={openDialog === INSTRUCTIONS} onClose={handleClose} data-testid={testIds.support.instructionsDialog}>
                <DialogTitle title='Instructions' onClose={handleClose} />
                <DialogContent>
                    <Typography variant='body1' component='p' gutterBottom>
                        To <Typography variant='subtitle1' component='span'>Verify Profile</Typography>, review the information in each section, make any necessary updates, and check the <Typography variant='subtitle1' component='span'>Verified</Typography> box in all six sections before selecting <Typography variant='subtitle1' component='span'>Review and Submit</Typography>. Completing this process is required to maintain a <Typography variant='subtitle1' component='span'>Verified Profile</Typography>, which is mandatory for OTCQX, OTCQB, OTCID, and Pink Limited companies.
                    </Typography>
                    <Typography variant='body1' component='p' gutterBottom>
                        To <Typography variant='subtitle1' component='span'>Update Profile</Typography>, navigate to the section that requires an update, make the necessary changes, and then proceed to <Typography variant='subtitle1' component='span'>Review</Typography>. Please note that updating information through this process does <Typography variant='subtitle1' component='span'>not</Typography> verify your profile. Maintaining a <Typography variant='subtitle1' component='span'>Verified Profile</Typography> is required for ongoing compliance.
                    </Typography>
                </DialogContent>
            </Dialog>

            <Dialog open={openDialog === HELP} onClose={handleClose} data-testid={testIds.support.helpDialog}>
                <DialogTitle title='Help' onClose={handleClose} />
                <DialogContent>
                    <HelpSection userEmail={userEmail} userFullName={userFullName} companyName={companyName} />
                </DialogContent>
            </Dialog>
        </>
    );
};

export default FormSupportActions;